/**
 * Search response — paginated results with total count.
 */
import { z } from 'zod';
import { SearchResultSchema } from './search-result.js';
export const SearchResponseSchema = z.object({
    results: z.array(SearchResultSchema),
    total: z.number(),
    offset: z.number(),
    hasMore: z.boolean(),
});
//# sourceMappingURL=search-response.js.map